import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component'),
  },
  {
    path: 'admin',
    loadComponent: () => import('./features/admin/admin.component'),
  },
  {
    path: 'privacidad',
    loadComponent: () => import('./features/privacy/privacy.component'),
  },
  { path: '**', redirectTo: '' },
];
